import React from "react";
import { motion } from "framer-motion";
import { BookOpenIcon, FileTextIcon, GlobeIcon, PrinterIcon, BoxIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { HERO_MOCKUP } from "../data/site";
import { PREVIEW_ANCHOR, PREVIEW_LINK_LABEL } from "../utils/checkout";
const formats: {
  icon: BoxIcon;
  label: string;
}[] = [{
  icon: FileTextIcon,
  label: 'Format PDF'
}, {
  icon: PrinterIcon,
  label: 'À imprimer ou à projeter'
}, {
  icon: GlobeIcon,
  label: 'En français, à adapter à votre pays'
}];
export function HeroSection() {
  return <section id="top" aria-labelledby="hero-title" className="bg-brand-ivory px-4 pb-10 pt-6 md:px-8 lg:py-12" data-id="element-129" data-mp="30n58ehv3b4es">
      <motion.div initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto grid w-full max-w-6xl items-center gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.05fr)] lg:gap-12" data-id="element-130" data-mp="2rsqrkauwvltk">
        <div className="flex flex-col items-center text-center lg:items-start lg:text-left" data-id="element-131" data-mp="2ff8sypz0u0tu">
          <p className="mb-3 text-[11px] font-extrabold uppercase tracking-[0.16em] text-brand-teal-ink sm:text-xs" data-id="element-132" data-mp="2be6tc816zmrc">
            PRIMAIRE ET SECONDAIRE · DE 6 À 18 ANS ENVIRON
          </p>
          <h1 id="hero-title" className="text-[1.85rem] font-extrabold leading-[1.1] tracking-tight text-brand-navy sm:text-[2.6rem] lg:text-[3.1rem] lg:leading-[1.05]" data-id="element-133" data-mp="2keljbkp3pq16">
            Vos cours de musique prennent forme.{' '}
            <span className="italic text-brand-teal" data-id="element-134" data-mp="2u57r4sqktc9b">Vos supports sont déjà là.</span>
          </h1>

          <div className="mt-4 overflow-hidden rounded-2xl bg-white p-1.5 shadow-lg shadow-brand-navy/10 ring-1 ring-brand-line lg:hidden" data-id="element-135" data-mp="384fsnsa7owgo">
            <img src={HERO_MOCKUP.src} alt={HERO_MOCKUP.alt} width={HERO_MOCKUP.width} height={HERO_MOCKUP.height} loading="eager" {...{
            fetchpriority: 'high'
          }} decoding="async" className="aspect-square h-[26svh] max-h-[340px] min-h-[190px] w-auto rounded-xl object-contain" data-id="element-136" data-mp="335w4dl85b8l5" />
          </div>

          <p className="mt-4 max-w-xl text-[15px] leading-relaxed text-slate-600 lg:text-lg" data-id="element-137" data-mp="38vnzopob5jb2">
            <strong className="font-bold text-slate-800" data-id="element-138" data-mp="3duiihrm9z7v6">10 tomes, 600 pages et 5 bonus</strong> en français pour
            préparer vos séances, faire pratiquer vos élèves et évaluer leurs progrès. Du primaire au secondaire,
            choisissez les ressources adaptées à votre classe.
          </p>

          <div className="mt-6 flex w-full flex-col items-center gap-3 sm:w-auto sm:flex-row lg:items-center" data-id="element-139" data-mp="3rqcr09j4zv7r">
            <CTAButton className="w-full px-8 sm:w-auto" data-id="element-140" data-mp="5cmaspf21x7t" />
            <a href={PREVIEW_ANCHOR} className="inline-flex min-h-[48px] w-full items-center justify-center gap-2 rounded-full px-6 text-sm font-extrabold tracking-wide text-brand-navy ring-1 ring-inset ring-brand-navy/25 transition-colors duration-150 ease-out hover:bg-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-teal sm:w-auto" data-id="element-141" data-mp="5d4g0bjp3lrv">
              <BookOpenIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-142" data-mp="23uoe70hntzvy" />
              {PREVIEW_LINK_LABEL}
            </a>
          </div>

          <ul className="mt-6 flex w-full flex-wrap justify-center gap-2 border-t border-brand-line pt-5 lg:justify-start" data-id="element-143" data-mp="1yu0gxx2u8mta">
            {formats.map(({
            icon: FormatIcon,
            label
          }) => <li key={label} className="inline-flex items-center gap-2 rounded-full bg-white px-3.5 py-2 text-xs font-semibold text-brand-navy ring-1 ring-brand-line" data-id="element-144" data-mp="1pwq4w9i74tnb">
                <FormatIcon className="h-4 w-4 text-brand-teal-ink" strokeWidth={2} aria-hidden="true" data-id="element-145" data-mp="2iklw4yozxtcp" />
                {label}
              </li>)}
          </ul>
        </div>

        <div className="mx-auto hidden w-full max-w-[560px] overflow-hidden rounded-3xl bg-white p-3 shadow-xl shadow-brand-navy/10 ring-1 ring-brand-line lg:block" data-id="element-146" data-mp="28uatrgkyns7x">
          <img src={HERO_MOCKUP.src} alt={HERO_MOCKUP.alt} width={HERO_MOCKUP.width} height={HERO_MOCKUP.height} loading="eager" {...{
          fetchpriority: 'high'
        }} decoding="async" className="aspect-square h-auto w-full rounded-2xl object-contain" data-id="element-147" data-mp="31i6mybbbn1zy" />
        </div>
      </motion.div>
    </section>;
}